import { Phone, MessageCircle, MapPin } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import { BUSINESS, GALLERY, waLink } from "../lib/constants";
import { usePageTitle } from "../lib/seo";

export default function Contact() {
  usePageTitle("Contact Us");
  return (
    <div>
      <PageHero
        eyebrow="Contact Us"
        title="Let's Plan Your Celebration"
        sub="Call, WhatsApp or send an enquiry — we usually reply within minutes during the day."
        image={GALLERY[3].src}
      />

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 md:py-24">
        <div className="grid gap-6 md:grid-cols-3">
          <Reveal>
            <a
              href={BUSINESS.phoneHref}
              data-testid="contact-card-phone"
              className="card-royal block h-full p-7 transition-all duration-300 hover:-translate-y-1"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#BF953F] to-[#AA771C] text-[#14120E]">
                <Phone className="h-5 w-5" />
              </span>
              <p className="mt-5 text-xs uppercase tracking-[0.2em] text-stone-500">Call us on</p>
              <p className="mt-2 font-display text-2xl text-amber-100">{BUSINESS.phone}</p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-gold">Tap to Call Now</p>
            </a>
          </Reveal>
          <Reveal delay={0.08}>
            <a
              href={waLink("Hello Jaiswal Tent House! I would like to enquire about your services.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-card-whatsapp"
              className="card-royal block h-full p-7 transition-all duration-300 hover:-translate-y-1"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-[#083b1d]">
                <MessageCircle className="h-5 w-5" />
              </span>
              <p className="mt-5 text-xs uppercase tracking-[0.2em] text-stone-500">WhatsApp us on</p>
              <p className="mt-2 font-display text-2xl text-amber-100">{BUSINESS.whatsapp}</p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#25D366]">Chat on WhatsApp</p>
            </a>
          </Reveal>
          <Reveal delay={0.16}>
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-card-location"
              className="card-royal block h-full p-7 transition-all duration-300 hover:-translate-y-1"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 text-gold">
                <MapPin className="h-5 w-5" />
              </span>
              <p className="mt-5 text-xs uppercase tracking-[0.2em] text-stone-500">Find us at</p>
              <p className="mt-2 font-display text-2xl text-amber-100">Bilaspur, Chhattisgarh</p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-gold">Open in Google Maps</p>
            </a>
          </Reveal>
        </div>

        <div className="mt-14 grid items-start gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="card-royal p-6 sm:p-8">
              <h2 className="font-display text-2xl text-amber-100">Booking &amp; Enquiry Form</h2>
              <p className="mt-1 text-xs text-stone-500">Your enquiry is saved to our booking inbox and opened in WhatsApp.</p>
              <div className="mt-6">
                <EnquiryForm />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-2xl border border-gold/20">
              <iframe
                title="Jaiswal Tent House location — Bilaspur, Chhattisgarh"
                src={BUSINESS.mapsEmbed}
                className="h-[420px] w-full border-0 grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="flex items-center justify-between gap-4 bg-[#14120E] p-5">
                <p className="text-sm text-stone-300">{BUSINESS.address}</p>
                <a
                  href={BUSINESS.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-maps-directions-btn"
                  className="shrink-0 rounded-full border border-gold/40 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-amber-300 transition-colors hover:bg-gold/15"
                >
                  Directions
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
